<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="row">
      <div class="col-md-12">
        <base-button type="primary" @click.prevent="onNew">
          <span class="btn-inner--icon">
            <i class="ni e-add"></i>
          </span>New student
        </base-button>
        <base-button type="info" @click.prevent="onRefresh" icon>
          <span class="btn-inner--icon">
            <i class="ni refresh-02"></i>
          </span>Refresh
        </base-button>
      </div>
    </div>
    <el-table :data="tableData" row-key="id" header-row-class-name="thead-light">
      <el-table-column label="Name" min-width="310px" prop="name" sortable>
        <template v-slot="{row}">
          <img
            :src="row.picture=== null ? nophoto : fileurl + row.picture"
            class="avatar rounded-circle mr-3"
          />
          <b>{{row.fullname}}</b>
        </template>
      </el-table-column>
      <el-table-column label="Start date" prop="startdate" min-width="140px" sortable></el-table-column>
      <el-table-column label="End date" prop="enddate" min-width="140px" sortable></el-table-column>
      <el-table-column label="notes" prop="notes"></el-table-column>
      <el-table-column min-width="120px" align="right" label="Actions">
        <div slot-scope="{$index, row}" class="d-flex">
          <base-button
            @click.native="onEdit($index, row)"
            class="edit"
            type="warning"
            size="sm"
            icon
          >
            <i class="text-white ni n-edit"></i>
          </base-button>
          <base-button
            @click.native="onDelete($index, row)"
            class="remove btn-link"
            type="danger"
            size="sm"
            icon
          >
            <i class="text-white ni e-remove"></i>
          </base-button>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform" size="lg">
      <h6 slot="header" class="modal-title">Student action</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Search student" :rules="{'required': mode === 'Create'}" name="student">
              <span v-if="mode === 'Edit'">{{student.fullname}}</span>
              <el-select
                v-if="mode === 'Create'"
                v-model="student.studentId"
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a name"
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in students"
                  :key="item.id"
                  :label="item.fullname"
                  :value="item.id"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Start date" rules="required" name="Start date">
              <flat-picker
                :config="{allowInput: true}"
                class="form-control datepicker"
                v-model="student.startdate"
              ></flat-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input label="End date">
              <flat-picker
                :config="{allowInput: true, minDate: student.startdate }"
                class="form-control datepicker"
                v-model="student.enddate"
              ></flat-picker>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input label="Notes" class="mr-1">
              <textarea class="form-control" rows="3" resize="none" v-model="student.notes"></textarea>
            </base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="primary" @click.native="onSaveStage">Save changes</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal, BaseAlert } from "@/components";
import { StudentType } from "../../../services/types";
import {
  GetStudents,
  GetStudent,
  DeleteStudent,
  CreateStudent,
  UpdateStudent,
} from "../../../services/classes";
import { SearchStudents } from "../../../services/user";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { nophoto, fileUrl } from "../../../services/helper";
export default {
  name: "students",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    HtmlEditor,
    Loading,
    flatPicker,
  },
  props: {
    classId: String,
    classStartDate: String,
  },
  computed: {
    mode() {
      return this.student.id ? "Edit" : "Create";
    },
    fileurl() {
      return fileUrl;
    },
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      modalform: false,
      student: {},
      students: [],
      loading: false,
    };
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          SearchStudents(query).then((response) => {
            this.loading = false;
            if (response.data.result) {
              this.students = response.data.result;
            } else this.students = [];
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    onRefresh(){
      this.loadStudents();
    },
    loadStudents() {
      if (!this.classId) {
        this.tableData = [];
        return;
      }
      this.isLoading = true;
      GetStudents(this.classId).then((response) => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onNew() {
      this.student = new StudentType();
      this.student.classId = this.classId;
      this.student.startdate = this.classStartDate;
      this.modalform = true;
    },
    onEdit(index, row) {
      this.student = Object.assign({}, row);
      this.modalform = true;
    },
    onSaveStage() {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            CreateStudent(this.student).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadStudents();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateStudent(this.student).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadStudents();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeleteStudent(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadStudents();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  mounted() {
    this.loadStudents();
  },
  watch: {
    classId: function () {
      this.loadStudents();
    },
  },
};
</script>
